


























































import Vue from "vue";
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from "vuex";
import NavNode from "@/services/NavigationNode";
import TreeExpander from '@/utils/TreeExpander';

@Component({
	name: 'TreeItem',
	computed: {
		...mapState(["selectedNodeUid", "expanded"])
	}
})
export default class TreeItem extends Vue {
	@Prop() item!: NavNode;
	@Prop({default: 0}) depth!: number;

	selectedNodeUid!: string;
	expanded!: boolean;

	isOpen = true;

	itemListMaxHeight: number | null = null;

	@Watch('expanded')
	onExpandedChange(val: boolean) {
		this.isOpen = val;
	}

	@Watch('isFolderOpen')
	updateExpandedHeight() {
		if (!this.isFolderOpen) {
			this.itemListMaxHeight = TreeExpander.getTreeHeight(this.item);
		}
	}

	created() {
		this.itemListMaxHeight = TreeExpander.getTreeMaxHeight(this.item);
	}

	get depthIndicationIcon() {
		return this.depth % 2 === 0 ? 'far fa-circle' : 'fas fa-circle';
	}

	get itemListStyle() {
		const style: { maxHeight?: string } = {};

		if (this.isFolderOpen) {
			style.maxHeight = ((this.itemListMaxHeight || 0) + 20) + 'px';
		}

		return style;
	}

	get isFolder() {
		return this.item.siteMap.canHaveChildren;
	}

	get isFolderOpen() {
		const showFolder = this.item.siteMap.canHaveChildren && (!this.item.hideChildren && this.item.enabled);
		return this.isOpen && showFolder;
	}

	get isSelected() {
		return this.selectedNodeUid === this.item.uid;
	}

	select() {
		this.$store.dispatch("setSelected", this.item.uid);
	}
}
// for recursion recognizing itself in "prod" compile mode
// Vue.component('TreeItem', TreeItem); in case `name` does not work.
